import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findDistributionAreaList= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionArea?`+params,
        method: 'GET'
    })
}
export const addDistributionArea= (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionArea`,
        method: 'POST',
        data: data
    })
}
export const editDistributionArea= (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionArea`,
        method: 'PUT',
        data: data
    })
}
export const delDistributionArea = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionArea/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
